import type { CSSProperties } from 'react';
import CaretDownIconSvg from '../../assets/icons/caret_down.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CaretDownIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CaretDownIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CaretDownIcon;
